<template>
  <div class="upgrade-to-premium container">
    <img
      src="../assets/images/home_banner.png"
      class="cover-art">
    <div class="luminary-logo">
      <img src="../assets/images/luminary_premium.png">
    </div>
    <div class="desc">
      <p>Go Premium</p>
      <p>
        Get access to 40+ originals and ad-free shows we're launching this year. Cancel anytime.
        <router-link
          to="/termsfreetrial"
          target="_blank"
          class="terms-apply"
        >
          Terms apply.
        </router-link>
      </p>
    </div>
    <div class="cta-btn">
      <router-link
        to="/premium-buy"
        class="el-button el-button--primary"
        data-test="btn-freetrial">Try
        <span
          v-if="promoMeta.trialPeriod > 1"
          class="line-through">1 month</span> {{ promoMeta.formattedTrialPeriod }} free</router-link>
      <p>followed by {{ localPricing.price | amountFilter(localPricing.currency) }} {{ localPricing.price | taxFilter(localPricing.currency) }}</p>
    </div>
  </div>
</template>

<script>
import PictureComponent from './PictureComponent';

export default {
  components: {
    PictureComponent,
  },
  data() {
    return {
    };
  },
  methods: {
    upgradeToPremium() {
      this.$router.push('/premium-buy');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../assets/scss/variables.scss";
  .upgrade-to-premium {
    padding: 0 50px;
    position: relative;
    background-color: $black1;
    margin-bottom: 60px;
    height: 200px;
    overflow: hidden;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .cover-art {
      position: absolute;
      top: 0;
      left: 0;
      max-width: 285px;
      height: 200px;
      z-index: 1;
      filter: brightness(.8);
    }
    .luminary-logo {
      z-index: 2;
      margin: 0 15px;
      img {
        max-width: 265px;
        height: auto;
      }
    }
    .desc {
      max-width: 400px;
      margin: 0 25px;
      p {
        color: #fff !important;
        font-family: Favorit-light;
        &:first-child {
          font-size: 20px;
          margin-bottom: 13px;
        }
        font-size: 18px;
      }
    }
    .cta-btn {
      margin: 0 15px;
      a {
        background-color: $brand;
        padding: 17px 35px;
        color: $black;
        border: none !important;
        text-transform: none;
      }
      p {
        color: #fff;
        font-family: Favorit-light;
        text-align: center;
        font-size: 14px;
        margin-top: 10px;
      }
    }

    .terms-apply {
      color: #9B9B9B;
      text-decoration: underline;
    }
  }
  @media (max-width: 1024px) {
    .upgrade-to-premium {
      padding: 0 15px;
      .luminary-logo {
        img {
          max-width: 225px;
        }
      }
      .desc {
        margin: 0 0 0 25px;
      }
      .cta-btn {
        margin: 0 0;
      }
    }
  }
  @media (max-width: 768px) {
    .upgrade-to-premium {
      padding: 25px 30px;
      margin-bottom: 0;
      flex-direction: column;
      height: 100% !important;
      &.container {
        width: 100%;
      }
      .cover-art {
        display: none;
      }
      .luminary-logo {
        img {
          max-width: 172px;
        }
      }
      .cta-btn {
        text-align: center;
      }
      .desc {
        max-width: 768px;
        text-align: center;
        margin: 15px 0 0 0;
        p {
          &:first-child {
            font-size: 16px;
          }
          font-size: 14px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// app/src/components/UpgradeToPremium.vue